import type { RegExpGroups } from "./RegExpGroups";
import type { MetadataMatch } from "./types";
import { LinearAppIcon } from "ls/features/disko/icons";
import LinearInlineCard from "./LinearInlineCard.vue";

export type LinearMetadataMatch = MetadataMatch & {
  name: "linear";
  key: string;
};

const patterns = [
  /^(https:\/\/)?linear\.app\/(?<workspace>[a-z0-9]+)\/issue\/(?<key>[a-z0-9]+-\d+)\/?(?<title>.*)?$/i,
] as const;

export function linear(url: string): LinearMetadataMatch | undefined {
  for (const pattern of patterns) {
    const result = url.match(pattern) as RegExpGroups<"key" | "workspace" | "title">;
    if (!result) continue;

    const key = result.groups?.key.toUpperCase();
    if (!key) continue;

    return {
      name: "linear",
      url,
      key,
      icon: LinearAppIcon,
      inlineCard: LinearInlineCard,
    };
  }

  return undefined;
}
